export default __webpack_public_path__ + "79dd956a2b49750bd2a4e64a9d259b27.svg";